import { labelId } from '../../../../features/labels/labels';
function toArray(value) {
  return Array.isArray(value) ? value : [];
}

function getCenterDisplayName(center) {
  const fullId = center?.centro || center?.modulos?.[0]?.cans?.[0]?.centro_id || "";
  if (!fullId) return "—";

  const parts = String(fullId).split("-");
  return parts[parts.length - 1]?.trim() || "—";
}

function getCenterDataStatus(center) {
  if (center?.__dataStatus || center?.data_status) {
    return center.__dataStatus || center.data_status;
  }

  if (center?.__sinDatos || center?.error) return "sin_estructura";
  return "sin_datos_recientes";
}

// Agrupa los centros descartados del render por su causa real. De esta forma
// un centro sin estructura no hereda el motivo de otro que solo está atrasado.
export function groupCentersWithoutData(centers, limit = 6) {
  const grouped = new Map();

  toArray(centers).forEach((center) => {
    const name = getCenterDisplayName(center);
    if (!name || name === "—") return;

    const status = getCenterDataStatus(center);
    const detail =
      center?.__dataStatusDetail ||
      center?.data_status_detail ||
      center?.__sinDatos ||
      center?.error ||
      "";
    const group = grouped.get(status) || {
      status,
      names: [],
      details: [],
    };

    group.names.push(labelId(center?.centro || center?.modulos?.[0]?.cans?.[0]?.centro_id, "rac", name));
    if (detail && !group.details.includes(detail)) group.details.push(detail);
    grouped.set(status, group);
  });

  return Array.from(grouped.values()).map((group) => {
    const shownNames = group.names.slice(0, limit).join(", ");
    return {
      ...group,
      count: group.names.length,
      namesLabel:
        group.names.length > limit
          ? `${shownNames} (+${group.names.length - limit})`
          : shownNames,
    };
  });
}
